import { render, staticRenderFns } from "./simpleTextStyle.vue?vue&type=template&id=02da6ab9&"
import script from "./simpleTextStyle.vue?vue&type=script&lang=ts&"
export * from "./simpleTextStyle.vue?vue&type=script&lang=ts&"
import style0 from "./simpleTextStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports